import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../aihobs-ecs.constants';

@Component({
  selector: 'app-aihobs-ecs-change-password-sent',
  templateUrl: './aihobs-ecs-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './aihobs-ecs-change-password-sent.component.css',
  ],
})
export class AihobsEcsChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void { }
}
